import React, { useContext, useEffect, useState } from 'react'
import './appbar.css'
import Logo from '../../assets/new_logo.svg'
import Search from '../../assets/search.svg'
import Notification from '../../assets/Notification.svg'
import Profile from '../../assets/user_default.png'
import { AppContext } from '../../provider'



export const AgentAppbar = () => {

    const { setSidebarIndex, setPageIndex, p_balance, p_getBalance, setExternalService, logout } = useContext(AppContext);
    const [query, setQuery] = useState("");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const data = [
        "Financial",
        "Banking",
        "Insurance",
        "Travel",
        "Ayushman Bharat",
        "Employment",
        "Passport",
        "PAN Card",
        "Loan",
        "Seller On Board",
        "Assisted Shopping",
        "Dashboard",
        "Deposit Payment",
        "All Service Requests",
        "Submit Service Request",
        "Transaction History",
        "Settings"
    ];
    const externalServices = [
        "Financial",
        "Banking",
        "Insurance",
        "Travel",
        "Ayushman Bharat",
        "Employment",
        "Passport",
        "PAN Card",
        "Loan",
        "Seller On Board",
        "Assisted Shopping"
    ];
    const filtered = data.filter(item =>
        item.toLowerCase().includes(query.toLowerCase())
    ).sort((a, b) => {
        const q = query.toLowerCase();
        const aStarts = a.toLowerCase().startsWith(q);
        const bStarts = b.toLowerCase().startsWith(q);

        if (aStarts && !bStarts) return -1;  // a first
        if (!aStarts && bStarts) return 1;   // b first

        return a.localeCompare(b); // normal alphabetical
    });

    function doSearch(key) {
        if (externalServices.includes(key)) {
            console.log("external services : " + key);
            setExternalService(key);
            setPageIndex(1);
            setSidebarIndex(0);
            return;
        }
        switch (key) {
            case "Dashboard":
                setPageIndex(0);
                setSidebarIndex(0);
                setQuery("");
                break;
            case "Deposit Payment":
                setPageIndex(0);
                setSidebarIndex(1);
                setQuery("");
                break;
            case "All Service Requests":
                setPageIndex(0);
                setSidebarIndex(2);
                setQuery("");
                break;
            case "Submit Service Request":
                setPageIndex(0);
                setSidebarIndex(3);
                setQuery("");
                break;
            case "Transaction History":
                setPageIndex(0);
                setSidebarIndex(5);
                setQuery("");
                break;
            case "Settings":
                setPageIndex(0);
                setSidebarIndex(6);
                setQuery("");
                break;

            default:
                break;
        }
    }

    useEffect(() => {
        p_getBalance();
    }, []);

    return <div className='appbar-div'>
        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '36px', marginTop: '10px', marginBottom: '15px' }}>
            <img style={{ paddingRight: '0px' }} src={Logo} alt="" />
            <span style={{ marginLeft: '10px' }} className='title'>
                GST Web Portal</span>
        </div>

        <div className='searchbar'>
            <img src={Search} alt="" />
            {/* <span className='search-text'>Search agents, CAs, customers, or services...</span> */}
            <input
                type="text"
                placeholder="Search services..."
                className="search-input"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
            />
            {query && (
                <div className="search-results">
                    {filtered.length > 0 ? (
                        filtered.map((item, index) => (
                            <div onClick={() => {
                                doSearch(item);
                                setQuery('');
                            }} className="search-item" key={index}>
                                {item}
                            </div>
                        ))
                    ) : (
                        <div className="no-results">No results found</div>
                    )}
                </div>
            )}
        </div>

        <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ fontFamily: 'Roboto', fontSize: '20', fontWeight: 'bolder', marginLeft: '10px', marginRight: '20px' }}>Balance: {p_balance}</span>
            <div className="profile-section" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                <img style={{ marginLeft: '10px', height: '25px', width: '25px' }} src={Profile} alt="" />
                <span style={{ fontFamily: 'Roboto', fontSize: '20', fontWeight: 'bolder', marginLeft: '10px', marginRight: '10px' }}>Agent</span>
                <span style={{ fontSize: '10px', transition: 'transform 0.2s', transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0)' }}>▼</span>
                
                {isDropdownOpen && (
                    <div className="profile-dropdown">
                        <div className="dropdown-item" onClick={logout}>
                            <span className="logout-icon">Logout</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    </div>

}